<template>
  <div class="confirm-signup">
    <div class="is-size-3 login-header">
      {{ $t('authenticator.confirm_sign_up') }}
    </div>
    <div class="field">
      <label class="label is-medium">{{ $t('authenticator.username') }} *</label>
      <div class="control">
        <input
          v-model="confirmation.username"
          class="input is-large"
          type="text"
          :placeholder="$t('authenticator.username_ph')"
        >
      </div>
    </div>
    <div class="field">
      <label class="label is-medium">{{ $t('authenticator.confirm_code') }} *</label>
      <div class="control">
        <input
          v-model="confirmation.code"
          class="input is-large"
          type="password"
          :placeholder="$t('authenticator.confirm_code')"
        >
      </div>
      <p class="help">
        {{ $t('authenticator.lost_code') }}
        <a @click.prevent="$emit('changeAuthState', $options.REQUIRE_NEW_PASSWORD)">
          {{ $t('authenticator.resend_code') }}
        </a>
      </p>
    </div>
    <div class="field">
      <div class="control">
        <button
          class="button is-primary is-large is-broad is-uppercase"
          @click="confirm"
        >
          {{ $t('common.confirm') }}
        </button>
        <p
          class="help"
        >
          {{ $t('authenticator.have_account') }}
          <a @click.prevent="$emit('changeAuthState', $options.SIGNED_OUT)">
            {{ $t('authenticator.back_to_sign_in') }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { REQUIRE_NEW_PASSWORD, SIGNED_OUT } from './auth-actions'
export default {

  name: 'ConfirmSignUp',
  data () {
    return {
      confirmation: {
        username: '',
        code: ''
      }
    }
  },
  created () {
    this.$options.REQUIRE_NEW_PASSWORD = REQUIRE_NEW_PASSWORD
    this.$options.SIGNED_OUT = SIGNED_OUT
  },
  methods: {
    /**
     * @vuese
     * Used to confirm sign up using AWS sdk
     */
    async confirm () {
      const { username, code } = this.confirmation
      try {
        await this.$auth.confirmSignUp(username, code)
        this.$emit('changeAuthState', this.$options.SIGNED_OUT)
      } catch (err) {
        this.$emit('displayError', err.message)
      }
    },
    /**
     * @vuese
     * Used to request another confirmation code using the AWS sdk
     */
    async resend () {
      const { username } = this.confirmation
      try {
        await this.$auth.resendSignUp(username)
      } catch (err) {
        console.log('err:', err)
        this.$emit('displayError', err.message)
      }
    }
  }

}
</script>
